class Header extends HTMLElement {
  constructor() {
    super();
    this.handleOnPageLoad = this.handleOnPageLoad.bind(this);
    this.handleOnScroll = this.handleOnScroll.bind(this);
  }

  connectedCallback() {
    this.navItems = this.querySelectorAll('[data-nav-item]');
    this.sublinks = this.querySelectorAll('[data-sublink]');
    this.lastWindowScrollTop = window.scrollY;

    window.addEventListener('load', this.handleOnPageLoad);
    window.addEventListener('scroll', this.handleOnScroll);
    this.sublinks.forEach((sublink) => {
      sublink.addEventListener(
        'mouseenter',
        this.handleSublinkMouseEnter.bind(this),
      );
    });
    this.navItems.forEach((navItem) => {
      navItem.addEventListener(
        'mouseenter',
        this.handleNavItemMouseEnter.bind(this),
      );
      navItem.addEventListener(
        'mouseleave',
        this.handleNavItemMouseLeave.bind(this),
      );
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleOnScroll);
  }

  handleOnPageLoad() {
    this.toggleSticky(window.scrollY >= this.offsetTop);
  }

  handleOnScroll() {
    this.toggleSticky(window.scrollY >= this.offsetTop);
  }

  handleNavItemMouseEnter(event) {
    const dropdownNav = event.target.querySelector('[data-dropdown-nav]');
    const dropdownMegamenu = event.target.querySelector(
      '[data-dropdown-megamenu]',
    );
    const predictiveSearch = this.querySelector(
      'predictive-search[data-type="desktop"]',
    );

    if (predictiveSearch) {
      predictiveSearch.close();
    }
  }

  handleNavItemMouseLeave() {
    this.sublinks.forEach((sublink) => sublink.classList.remove('is-active'));

    this.querySelectorAll('[data-dropdown-features]').forEach((featuresCards) =>
      featuresCards.classList.remove('hidden'),
    );

    this.querySelectorAll('[data-dropdown-cards]').forEach((target) =>
      target.classList.add('hidden'),
    );
  }

  handleSublinkMouseEnter(event) {
    const dropdown = event.target.closest('[data-dropdown]');
    const features = dropdown.querySelector('[data-dropdown-features]');
    const sublinkTargets = dropdown.querySelectorAll('[data-dropdown-cards]');
    const sublinkTarget = dropdown.querySelector(
      `[data-dropdown-cards="${event.target.dataset.sublink}"]`,
    );

    if (!sublinkTarget) {
      this.sublinks.forEach((sublink) => sublink.classList.remove('is-active'));
      sublinkTargets.forEach((target) => target.classList.add('hidden'));
      if (features) features.classList.remove('hidden');
      return;
    }

    features.classList.add('hidden');
    this.sublinks.forEach((sublink) =>
      sublink.classList.toggle(
        'is-active',
        sublink.dataset.sublink === event.target.dataset.sublink,
      ),
    );
    sublinkTargets.forEach((target) =>
      target.classList.toggle('hidden', target !== sublinkTarget),
    );
  }

  toggleSticky(flag) {
    this.classList.toggle('is-fixed', flag);
  }
}

customElements.define('section-header', Header);
